<template>
  <div>
    <side-bar-big class-name="second"></side-bar-big>
    <div class="home">
      <app-landing-page/>
      <div>
        <b-container>
          <app-about/>
          <app-projects/>
          <app-skills/>
        </b-container>
      </div>
      <div>
        <b-container class="exp_edu_container">
          <b-row>
            <b-col cols="12" lg="8" class="exp_edu_center">
              <app-experience/>
              <app-education/>
            </b-col>
            <b-col cols="12" lg="4" class="exp_edu_menu">
              <social-menu></social-menu>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div>
        <b-container>
          <app-hobbies/>
          <app-contact/>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import LandingPage from './LandingPage.vue'
import SocialMenu from '../components/SocialMenu.vue'
import SideBarBig from '../components/SideBarBig.vue'
import About from './About.vue'
import Projects from './Projects.vue'
import Skills from './Skills.vue'
import Experience from './Experience.vue'
import Education from './Education.vue'
import Hobbies from './Hobbies.vue'
import Contact from './Contact.vue'

export default {
    name: 'Home',
    data () {
        return {
        }
    },
    components: {
        appLandingPage: LandingPage,
        SocialMenu,
        SideBarBig,
        appAbout: About,
        appProjects: Projects,
        appSkills: Skills,
        appExperience: Experience,
        appEducation: Education,
        appHobbies: Hobbies,
        appContact: Contact,
    },
}
</script>

<style scoped lang="scss">
@import '../styles/views/Home.scss'
</style>
